import { render } from "./StudentVerificationView.vue?vue&type=template&id=3723979c&scoped=true"
import script from "./StudentVerificationView.vue?vue&type=script&lang=js"
export * from "./StudentVerificationView.vue?vue&type=script&lang=js"

import "./StudentVerificationView.vue?vue&type=style&index=0&id=3723979c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3723979c"]])

export default __exports__